import Component from '@cell/cell-core/component/component';
import './cart-line-item.scss';

class CartLineItem extends Component {
  constructor() {
    super();

    this.key = this.parsedDataset.key;

    this.lineItem = {
      productId: this.parsedDataset.productId,
      productTitle: this.parsedDataset.productTitle,
      productType: this.parsedDataset.productType,
      productVendor: this.parsedDataset.productVendor,
      variantId: this.parsedDataset.variantId,
      variantTitle: this.parsedDataset.variantTitle,
      variantPrice: this.parsedDataset.variantPrice,
    };

    this.maxQuantityErrorMessageTemplate = this.querySelector(
      '.CartLineItem__Error .Text',
    ).textContent;

    this.handleQuantityUpdate = this.handleQuantityUpdate.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleShowItemComponents = this.handleShowItemComponents.bind(this);
    this.handleHideItemComponents = this.handleHideItemComponents.bind(this);
  }

  componentDidMount() {
    this.on('quantity-selector.update', this.handleQuantityUpdate);

    this.on('c-button.click.remove-line-item', this.handleRemove);

    this.on('c-button.click.show-item-components', this.handleShowItemComponents);
    this.on('c-button.click.hide-item-components', this.handleHideItemComponents);
  }

  handleQuantityUpdate(event) {
    if (event.data.quantity === 0) {
      this.handleRemove();

      return;
    }

    this.setLoading(true);

    this.emit('update-quantity', {
      key: this.key,
      quantity: event.data.quantity,
      previousQuantity: event.data.previousQuantity,
    });
  }

  handleRemove() {
    this.setLoading(true);

    this.emit('remove', {
      key: this.key,
    });
  }

  handleShowItemComponents() {
    const componentsElement = this.querySelector('.CartLineItem__Components');

    componentsElement.classList.add('CartLineItem__Components--Active');
  }

  handleHideItemComponents() {
    const componentsElement = this.querySelector('.CartLineItem__Components');

    componentsElement.classList.remove('CartLineItem__Components--Active');
  }

  setLoading(force) {
    this.classList.toggle('CartLineItem--Loading', force);
  }

  showMaxQuantityError() {
    const currentQuantity = this.querySelector('quantity-selector').quantity;

    this.querySelector('.CartLineItem__Error .Text').textContent =
      this.maxQuantityErrorMessageTemplate.replace('{{ max_quantity }}', currentQuantity);

    this.querySelector('.CartLineItem__Error').classList.add('CartLineItem__Error--Visible');

    this.setLoading(false);
  }
}

customElements.define('cart-line-item', CartLineItem);
